import config from "../../config";
import { withCommonHeaders } from "./add-headers";

export default withCommonHeaders(config);
